import { Middleware } from "@reduxjs/toolkit";
import { setError } from "../features/notification/error-slice";
import { DatabaseLogger } from "../../services/logging/logger";

const errorHandlingMiddleware: Middleware = ({ dispatch }) => (next) => (action: any) => {
    if (action.type.endsWith("rejected")) {
        const logger = new DatabaseLogger();

        const errorMessage =
            action?.payload || action.type || action.payload || "Unknown error";
        const errorStack = action?.meta ? JSON.stringify(action.meta) : action.type;

        logger.error(errorMessage, errorStack);

        dispatch(setError(errorMessage));
    }

    return next(action);
};

export default errorHandlingMiddleware;
